import { useRef, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentStatus";

function App() {
  const lenisRef = useRef(null);
  useEffect(() => {
    if (lenisRef.current?.lenis) window.__lenis = lenisRef.current.lenis;
  });
  return (
    <div className="App">
      <ReactLenis ref={lenisRef} root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
      </ReactLenis>
    </div>
  );
}

export default App;
